import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentCategoriesComponent } from './document-categories.component';
import { AddDocumentCategoriesComponent } from './add-document-categories/add-document-categories.component';
import { EditDocumentCategoriesComponent } from './edit-document-categories/edit-document-categories.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        DocumentCategoriesComponent,
        AddDocumentCategoriesComponent,
        EditDocumentCategoriesComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [DocumentCategoriesComponent],
})
export class DocumentCategoriesModule { }
